function handleBonusCodeClick(bonusCodeCta) {
  const theBonusCodeCta = bonusCodeCta.currentTarget
  const value = theBonusCodeCta.querySelector('[class*="value"] span')
  if (!value) return

  const { copiedtext, promocode, visit } = value.dataset

  if (theBonusCodeCta.dataset.url && !theBonusCodeCta.classList.contains('has-code') && !theBonusCodeCta.dataset.cpcopy) {
    window.open(theBonusCodeCta.dataset.url)
  } else {
    navigator.clipboard.writeText(promocode).then(() => {
      document.querySelectorAll(`.${theBonusCodeCta.classList[0]}`).forEach((bonusCodeCtaCopied) => {
        const button = bonusCodeCtaCopied.querySelector('[class*="button"]')
        button.innerHTML = copiedtext
        bonusCodeCtaCopied.classList.add('copied')
      })
      delete theBonusCodeCta.parentElement.querySelector('.btn').dataset.target
    })
    if (!theBonusCodeCta.classList.contains('has-code') && theBonusCodeCta.dataset.cpcopy) {
      setTimeout(() => {
        document.querySelectorAll(`.${theBonusCodeCta.classList[0]}`).forEach((bonusCodeCtaCopied) => {
          bonusCodeCtaCopied.querySelector('[class*="button"]').innerHTML = visit
          bonusCodeCtaCopied.classList.add('visit')
        })
      }, 2000)
    }
    if (theBonusCodeCta.classList.contains('visit')) {
      window.open(theBonusCodeCta.dataset.url)
    }
  }
}

function handleCtaButtonClick(CtaButton) {
  const theCtaButton = CtaButton.currentTarget

  if (theCtaButton.dataset.url) {
    window.open(theCtaButton.dataset.url)
  } else {
    const buttonCta = CtaButton.target.parentElement
    if (buttonCta.dataset.cpcopy) {
      navigator.clipboard.writeText(buttonCta.dataset.promocode)
    } else if (theCtaButton.parentElement.dataset.showcopy) {
      if (theCtaButton.parentElement.dataset.promocode) {
        navigator.clipboard.writeText(theCtaButton.parentElement.dataset.promocode)
      }

      window.open(decodeURIComponent(window.atob(theCtaButton.dataset.link)))
    }
  }
}
function handleCtaButtonCopyClick(CtaButtonCopy) {
  const parentElement = CtaButtonCopy.currentTarget.parentElement
  if (!parentElement.classList.contains('clicked')) {
    navigator.clipboard.writeText(parentElement.dataset.promocode)
    const btn = parentElement.querySelector('.btn')
    parentElement.classList.add('changing')
    btn.innerHTML = parentElement.dataset.copiedtext
    setTimeout(() => {
      parentElement.classList.remove('changing')
      parentElement.classList.add('clicked')
      btn.innerHTML = parentElement.dataset.visit
    }, 2000)
  }
}
function removeEventListeners(selector, eventType, handler) {
  const elements = document.querySelectorAll(selector)
  elements.forEach((element) => {
    element.removeEventListener(eventType, handler)
  })
}
function addEventListeners(selector, eventType, handler) {
  const elements = document.querySelectorAll(selector)
  elements.forEach((element) => {
    element.addEventListener(eventType, handler)
  })
}

function handleClick() {
  setTimeout(() => {
    removeEventListeners('.hostname-bonus-code', 'click', handleBonusCodeClick)
    removeEventListeners('.hostname-container .btn', 'click', handleCtaButtonClick)
    removeEventListeners('.hostname-container .container-btn-col', 'click', handleCtaButtonCopyClick)
    addEventListeners('.hostname-bonus-code', 'click', handleBonusCodeClick)
    addEventListeners('.hostname-container .btn', 'click', handleCtaButtonClick)
    addEventListeners('.hostname-container .container-btn-col', 'click', handleCtaButtonCopyClick)
  }, 100)
}

function addEventListenersCouponsTable(coupon) {
  coupon.querySelectorAll('[class*="bonus-code"]').forEach((el) => el.addEventListener('click', handleBonusCodeClick))
  coupon.querySelectorAll('.btn').forEach((el) => el.addEventListener('click', handleCtaButtonClick))
  coupon.querySelectorAll('[class*="container-btn-col"]').forEach((el) => el.addEventListener('click', handleCtaButtonCopyClick))
}

function triggerLoadMoreIfCouponTable() {
  const urlParams = new URLSearchParams(window.location.search)
  if (urlParams.get('couponTable') === '1') {
    triggerLoadMoreCoupons()
  }
}

function triggerLoadMoreCoupons() {
  if (window.triggeredLoadMore) return
  window.triggeredLoadMore = true

  const couponsTable = document.querySelector('.coupons-table')
  const loadMoreBtn = couponsTable.querySelector('.load-more-coupons')
  if (loadMoreBtn) {
    setTimeout(() => loadMoreBtn.click(), 0)
  }
}

const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === 1 && node.matches('[id*="cta-"]')) {
        addEventListenersCouponsTable(node)
      }
    })
  })
})
const couponsTable = document.querySelector('.coupons-table')
if (couponsTable) {
  observer.observe(document.querySelector('.coupons-table'), { childList: true, subtree: true })
}
const modalObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === 1 && node.classList.contains('cp-modal')) {
        const coupons = node.querySelectorAll('[id*="cta-"]')
        coupons.forEach((coupon) => {
          addEventListenersCouponsTable(coupon)
        })
      }
    })
  })
})

modalObserver.observe(document.body, { childList: true, subtree: true })

function initExistingCoupons() {
  document.querySelectorAll('[id*="cta-"]').forEach((coupon) => {
    addEventListenersCouponsTable(coupon)
  })
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    handleClick()
    initExistingCoupons()
    triggerLoadMoreIfCouponTable()
  })
} else {
  handleClick()
  initExistingCoupons()
  triggerLoadMoreIfCouponTable()
}
window.onpageshow = function (event) {
  if (event.persisted) {
    handleClick()
    initExistingCoupons()
    triggerLoadMoreIfCouponTable()
  }
}
